import { Component, Input, OnInit, Optional } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { BaseInputDirective } from '../base-input.directive';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import * as moment from 'moment-timezone';
import { ErrorService } from '../../services/form-utility/error.service';
import { ErrorDefinition } from '../../models/error-definition';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],

  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'M/D/YYYY',
        },
        display: {
          dateInput: 'MM/DD/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class DateInputComponent extends BaseInputDirective implements OnInit {
  minValueDisplay: string;
  maxValueDisplay: string;
  @Input() showEstOnReadOnly: boolean = false;

  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.hint == null) {
      this.hint = '(mm/dd/yyyy)';
    }

    this.adjustErrorMessages();
  }

  dateChanged(event: any) {
    // this.formControl.value will be null if the format is invalid. This is set by the Material datepicker
    if (this.formControl.value == null && event.targetElement.value !== '') {
      this.formControl.setErrors({ invalidDateFormat: true });
    }

    if (event.target.value) {
      event.target.value.utcOffset(new Date(event.target.value).getTimezoneOffset());
      this.change.emit(event.target.value);
    } else {
      this.change.emit(null);
    }
  }

  private adjustErrorMessages() {
    this.minValueDisplay = moment(this.fgInfo.minValue).format('MM/DD/YYYY');
    this.maxValueDisplay = moment(this.fgInfo.maxValue).format('MM/DD/YYYY');

    const minErrorDefinition = this.errorDefinitions.find(
      (value: ErrorDefinition) => value.key === 'min',
    );
    const maxErrorDefinition = this.errorDefinitions.find(
      (value: ErrorDefinition) => value.key === 'max',
    );

    minErrorDefinition.errorMessage = this.errorService.convertMessageToFn(
      `${this.fgInfo.label} must be after ${this.minValueDisplay}`,
    );
    maxErrorDefinition.errorMessage = this.errorService.convertMessageToFn(
      `${this.fgInfo.label} must be before ${this.maxValueDisplay}`,
    );
  }
}
